import { render, staticRenderFns } from "./percentage-bar.vue?vue&type=template&id=8048c8c4&"
import script from "./percentage-bar.vue?vue&type=script&lang=js&"
export * from "./percentage-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports